module.exports = __webpack_public_path__ + "media/images/clipboard-list-check-fa53e5fb.svg";